import React, { useRef, useEffect } from "react";
import "../styles/typography.css";
import styles from "../styles/ChatClassification.module.css";

interface Props {
  inputText: string;
  setInputText: React.Dispatch<React.SetStateAction<string>>;
  sendMessage: () => void;
  handleKeyPress: (e: React.KeyboardEvent<HTMLTextAreaElement>) => void;
  isLoading: boolean;
}

const ChatInput: React.FC<Props> = ({
  inputText,
  setInputText,
  sendMessage,
  handleKeyPress,
  isLoading,
}) => {
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  // Auto-expande o textarea (estilo ChatGPT)
  useEffect(() => {
    const textarea = textareaRef.current;
    if (textarea) {
      textarea.style.height = "auto";
      const maxHeight = 120; // ~5 linhas
      textarea.style.height = Math.min(textarea.scrollHeight, maxHeight) + "px";
    }
  }, [inputText]);

  return (
    <div className={`${styles.chatInput} ${isLoading ? styles.disabled : ""}`}>
      <div className={styles.inputWrapper}>
        <textarea
          ref={textareaRef}
          value={inputText}
          onChange={(e) => setInputText(e.target.value)}
          onKeyPress={handleKeyPress}
          placeholder="Digite a sua mensagem..."
          disabled={isLoading}
          rows={1}
        />
        <button
          onClick={sendMessage}
          disabled={isLoading || !inputText.trim()}
          className={styles.sendInside}
          aria-label="Enviar mensagem"
        >
          {isLoading ? (
            <span className={styles.sendingDots}>
              <span></span><span></span><span></span>
            </span>
          ) : (
            <img
              src="/ChatWidget/images/send-message.png"
              alt="Enviar"
              className={styles.sendIcon}
            />
          )}
        </button>
      </div>

      {/* Rodapé (Powered by) */}
      <div className={styles.poweredBy}>
        <img
          src="/ChatWidget/images/only_logo_insia_cinza.png"
          alt="INSIA"
          className={styles.poweredByLogo}
          onError={(e) => {
            (e.currentTarget as HTMLImageElement).src =
              "/ChatWidget/images/only_logo_insia_cinza.png";
          }}
        />
        <span>Powered by INSIA</span>
      </div>
    </div>
  );
};

export default ChatInput;
